module.exports = __webpack_public_path__ + "static/media/lekan.1a3e7294.png";